/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/root_options.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/


class LpRootOptions {
  constructor() {
    this.roots = {};
  }

  buildRootOptions(sections = []) {
    sections.forEach((idx) => {
      idx.options.forEach((jdx) => {
        this.roots[jdx] = true;
      }, this);
    }, this);
  }
}


export default LpRootOptions;



// WEBPACK FOOTER //
// ./src/app/indexes/root_options.js